module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-items-center justify-content-center welcome-content"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center welcome-header"
  }, [_c('span', {
    staticClass: "mr-3"
  }, [_vm._v("👋")]), _vm._v(" "), _c('h1', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('modal.welcome')) + " " + _vm._s(_vm.account.first_name) + " !")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-30"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/826078811",
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allow": "autoplay; fullscreen; picture-in-picture",
      "allowfullscreen": "",
      "title": "welcome-outil.mov"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "start-now-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-center waves-effect waves-classic btn-save text-uppercase"
  }, [_c('a', {
    staticClass: "start-link text-decoration-none",
    attrs: {
      "href": "https://superhote.com/onboarding-tuto",
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('button.get_started')))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04618912"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/account/onboarding/Onboarding.vue
// module id = 1288
// module chunks = 0